import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/faq/components/FAQAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SlideUp"] */ "/vercel/path0/src/components/ui/motion.tsx");
